import styled from 'styled-components';

// @ts-nocheck
var IncludedProducts = styled.div.withConfig({
  displayName: "IncludedProductsstyle__IncludedProducts",
  componentId: "sc-5tkcwa-0"
})([""]);
var Products = styled.div.withConfig({
  displayName: "IncludedProductsstyle__Products",
  componentId: "sc-5tkcwa-1"
})(["display:flex;gap:var(--space-300);flex-wrap:wrap;"]);
var ProductsTitle = styled.div.withConfig({
  displayName: "IncludedProductsstyle__ProductsTitle",
  componentId: "sc-5tkcwa-2"
})(["width:100%;margin-bottom:var(--space-100);"]);
var Product = styled.div.withConfig({
  displayName: "IncludedProductsstyle__Product",
  componentId: "sc-5tkcwa-3"
})(["flex-basis:calc(50% - var(--space-300)/2);display:flex;"]);
var ProductImageWrapper = styled.div.withConfig({
  displayName: "IncludedProductsstyle__ProductImageWrapper",
  componentId: "sc-5tkcwa-4"
})(["margin-right:var(--space-300);max-height:95px;max-width:100px;"]);
var ProductContentWrapper = styled.div.withConfig({
  displayName: "IncludedProductsstyle__ProductContentWrapper",
  componentId: "sc-5tkcwa-5"
})(["display:flex;flex-direction:column;"]);
var ProductTitle = styled.div.withConfig({
  displayName: "IncludedProductsstyle__ProductTitle",
  componentId: "sc-5tkcwa-6"
})(["font:var(--font-headline-xs);"]);
var ProductSubtitle = styled.div.withConfig({
  displayName: "IncludedProductsstyle__ProductSubtitle",
  componentId: "sc-5tkcwa-7"
})(["font:var(--font-body-s);color:var(--color-text-subtle);"]);

export { IncludedProducts, Product, ProductContentWrapper, ProductImageWrapper, ProductSubtitle, ProductTitle, Products, ProductsTitle };
//# sourceMappingURL=IncludedProducts.style.js.map
